const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_sv_part1 = {
  tokenMissing: "Token eller chatbotID hittades inte",
  choosePeriod: "Period",
  topicFilterLabel: "Ämne",
  topicFilterAllPlaceholder: "Alla ämnen",
  topicFilterOtherOption: "Övrigt",
  topicFilterArchivedLabel: "arkiverat",
  topicFilterClear: "Rensa ämnesfilter",
  topicFilterSelectedCount: "{count} ämnen",
  topicGroupSave: "Spara som grupp",
  topicGroupSaveConfirm: "Spara",
  topicGroupName: "Gruppnamn",
  topicGroupNamePlaceholder: "T.ex. Kundservice",
  topicGroupDelete: "Ta bort grupp",
  topicFilterReportNotice:
    "Sidans ämnesfilter används inte i rapporter – rapporten täcker alla ämnen.",
  allTimes: "Alla tider",
  last7Days: "Senaste 7 dagarna",
  last30Days: "Senaste 30 dagarna",
  last3Months: "Senaste 3 månaderna",
  yesterday: "Igår",
  today: "Idag",
  customRange: "Anpassad",
  statisticsTabPerformance: "AI-prestanda",
  statisticsTabTopics: "Ämnen och konversationer",
  statisticsTabListLabel: "Statistikavsnitt",
  overviewSectionTitle: "Översikt",
  resolutionSectionTitle: "Lösning",
  aiEffectivenessSectionTitle: "AI-effektivitet",
  commerceSectionTitle: "Affärspåverkan",
  comparePreviousPeriod: "Jämför med föregående period",
  vsPreviousPeriod: "jämfört med föregående period",
  comparePreviousPeriodTooltip:
    "Visar hur varje KPI förändrades jämfört med den direkt föregående perioden av samma längd.",
  comparePreviousPeriodUnavailableTooltip:
    "Jämförelse är inte tillgänglig för Alla tider eftersom det inte finns någon giltig föregående period.",
  comparePreviousPeriodInfo: "Info om jämförelse med föregående period",
  lastUpdated: "Senast uppdaterad",
  refresh: "Uppdatera",
  actions: "Åtgärder",
  allChatbots: "Alla chatbotar",
  conversationsBySource: "Konversationer per källa",
  conversationsBySourceTotal: "{total} konversationer under den valda perioden",
  noSourceData: "Ingen källuppdelning tillgänglig för den här perioden.",
  statisticsLoadError: "Kunde inte läsa in statistik",
  statisticsLoadErrorDescription: "Prova att uppdatera sidan.",
  outcomeBreakdownTitle: "Lösningsresultat",
  outcomeBreakdownPartitionHint:
    "Varje segment är en andel av klassificerade konversationer (de med en lösningskategori) och summerar till 100 %. Oklassificerade konversationer exkluderas.",
  resolutionTotalLabel: "Klassificerade konversationer",
  resolutionCoverageLabel: "Klassificerade konversationer: {classified} av {total} ({percent}%)",
  activitySectionTitle: "Aktivitet",
  hourLabel: "Timme",
  messagesLabel: "Meddelanden",
  performanceSectionDescription:
    "AI-effektivitet, eskalationer och engagemang för den valda perioden.",
  satisfactionChartsTitle: "Nöjdhet",
  statisticsSettingsDescription: "Konfigurera öppettider, synliga mätvärden och ämneshantering.",
  notificationsSheetDescription: "Få avisering när ämnets volym överstiger ett tröskelvärde.",
  viewTopicDetails: "Visa ämnesdetaljer",
  livechatVolumeTitle: "Livechat-volym",
  livechatSatisfactionTitle: "Livechat-nöjdhet",
  livechatTopicsTitle: "Livechat-ämnen",

  insights: "Insikter",
  totalMessages: "Totalt antal meddelanden",
  avgMessagesPerDay: "Genomsnittliga meddelanden per dag",
  totalConversations: "Totalt antal konversationer",
  totalUserRatings: "Totalt antal användaromdömen",
  averageRating: "Genomsnittligt användaromdöme",
  thumbsUpPercentage: "Andel tummen upp",
  csatScore: "Kundnöjdhet (CSAT)",
  chatbotSatisfaction: "Chatbot-nöjdhet",

  dailyMessages: "Dagliga meddelanden",
  weeklyMessages: "Veckovisa meddelanden",
  weekOf: "Vecka från",
  ongoingDay: "Pågående dag",
  weekInProgress: "pågående vecka",
  loadingDailyData: "Laddar daglig data...",
  topicMessages: "Konversationer per ämne",
  loadingTopicData: "Laddar ämnesdata...",
  timeOfDay: "Tid på dygnet",
  loadingHourlyData: "Laddar timvis data...",
  ratingDistribution: "Omdömesfördelning (1–5)",
  ratingDistributionTooltip:
    "Antal konversationer med ett användaromdöme på varje nivå (heltalsomdömen 1–5 endast).",
  ratingDistributionEmpty: "Inga omdömen ännu för den här perioden",
  csatOverTime: "CSAT över tid",
  csatOverTimeTooltip: "Genomsnittlig kundnöjdhet (CSAT) per period i det valda datumintervallet.",
  csatOverTimeEmpty: "Inga omdömen ännu för den här perioden",
  csatOverTimeYAxis: "CSAT (%)",
  csatRegressionLine: "Trendlinje",
  csatRegressionSlopeDay: "{{slope}} pp / dag",
  csatRegressionSlopeWeek: "{{slope}} pp / vecka",
  csatRegressionSlopeMonth: "{{slope}} pp / månad",
  resolutionOverTime: "Lösningsfrekvens över tid",
  resolutionOverTimeEmpty: "Inga klassificerade konversationer ännu för den här perioden",
  resolutionOverTimeYAxis: "Lösning (%)",
  csatOverTimeChartSetting: "CSAT över tid-diagram",
  csatOverTimeChartSettingTooltip:
    "Visa ett linjediagram över hur CSAT-poängen förändras över det valda datumintervallet.",

  dateLabel: "Datum",
  messageCount: "Antal meddelanden",
  topicLabel: "Ämne",
  conversationCount: "Konversationer",
  openCount: "Öppningar",
  timeLabel: "Tid",
  showAll: "Visa alla",
  showLess: "Visa färre",
  other: "Övrigt",
  percentage: "Procent",

  outsideBusinessHours: "Utanför öppettider",
  outsideBusinessHoursTooltip: "Andel meddelanden skickade utanför öppettiderna",
  outsideBusinessHoursTooltipDescription: "Andel meddelanden skickade utanför öppettiderna",

  averageTtft: "Genomsn. tid till första token",
  averageTtftTooltip: "Genomsnittlig tid från mottaget meddelande till första token skickas",
  p50Ttft: "P50 tid till första token",
  p50TtftTooltip:
    "Median (50:e percentilen) tid från mottaget meddelande till första token skickas",
  p95Ttft: "P95 tid till första token",
  p95TtftTooltip: "95:e percentilens tid från mottaget meddelande till första token skickas",
  p99Ttft: "P99 tid till första token",
  p99TtftTooltip: "99:e percentilens tid från mottaget meddelande till första token skickas",
  responseLatencyMetrics: "Svarstider (TTFT, P50, P95)",
  responseLatencyMetricsTooltip:
    "Visa tid till första token samt P50- och P95-svarstider på statistiksidan",
  p99LatencyMetric: "Svarstid (P99)",
  p99LatencyMetricTooltip: "Visa P99-tid till första token på statistiksidan",
  ttftBreakdownLabel: "Tidsfördelning till första token",
  totalTtft: "Total TTFT",
  detailedBreakdown: "Detaljerad tidsfördelning (i ordning)",
  noTtftData: "Inga TTFT-data tillgängliga",

  [duplicateTranslationKey("outsideBusinessHoursTooltipDescription")]:
    "Andel meddelanden skickade utanför öppettiderna",
  startTime: "Starttid",
  endTime: "Sluttid",
  weekendHours: "Helgöppettider",
  saturdayHours: "Lördag",
  sundayHours: "Söndag",
  weekendHoursTooltip: "Andel meddelanden skickade under helgöppettiderna",
  weekendHoursTooltipDescription: "Andel meddelanden skickade under helgöppettiderna",
  [duplicateTranslationKey("weekendHoursTooltipDescription")]:
    "Andel meddelanden skickade under helgöppettiderna",
  supportHours: "Supportens öppettider",
  settingsSaved: "Inställningar sparade",
  settingsSaveError: "Fel vid sparande av inställningar",
  businessHoursInvalidRange:
    "Sluttiden måste vara senare än starttiden. Öppettiderna sparades inte.",
  weekendSupport: "Support under helgen",
};
